/*
 * Композер (prototype/Prototype.dc.html:1491 — конец панели карточки брони; 1386–1390 — копия на
 * экране «Чаты»). Числа сведены к копии карточки, как и вся лента: у «Чатов» padding 11px 14px 12px
 * и пилюля h25 — см. docs/reference/phase-2-mockup.md, раздел 4.
 *
 * Своего фона нет: панель чата уже `--panel` (`widgets/booking-modal`, `.chat`). Копия «Чатов»
 * ставит `background: var(--panel)` только потому, что лежит на `--bg`.
 */
.root {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 9px;
  padding: 11px 13px 12px;
  border-top: 1px solid var(--line);
}

/*
 * Пилюля канала. `--msg` приезжает инлайном из `messengerToken(channel)` — тот же приём, что
 * у `--tint` в `BookingStatusChip` и `SystemEvent`: один элемент красится под любой канал без
 * веток в CSS.
 *
 * Пилюля — настоящий селектор канала (`<button>` + `Popover`): лента брони мультиканальна, и
 * `sendMessage.channelKind` выбирает, каким родом слать. Прежде дропдауна не было (переписка была
 * привязана к одному каналу) — теперь есть; вид тот же, интерактивность вернулась.
 *
 * ТЕКСТ — `--ink`, а не `--msg`, и это макет v5 (правило 2: цветной текст на заливке из ТОГО ЖЕ
 * цвета не берёт AA по построению — заливка светлеет, текст остаётся насыщенным, обе стороны
 * сходятся). Было 3.34 : 1 при норме 4.5, стало 14.72. Цветными остались заливка, кайма и кружок
 * — на них и держится «этот канал такой-то».
 *
 * Отдельно про `email`: `messengerToken` красит его в `--sunk`, то есть почти в саму заливку —
 * кружок там даёт 1.12 : 1 и не сообщает НИЧЕГО. Пилюля читается только текстом, и `--ink` тут
 * не «на всякий случай», а единственное, что вообще работает во всех шести каналах разом.
 */
.pill {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 7px;
  height: 26px;
  padding: 0 11px 0 9px;
  border: 0;
  border-radius: 999px;
  background: color-mix(in oklch, var(--msg) 14%, var(--tint-on));
  box-shadow: inset 0 0 0 1px color-mix(in oklch, var(--msg) 32%, transparent);
  color: var(--ink);
  font: inherit;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.pillDot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--msg);
}

.pillChevron {
  flex-shrink: 0;
  opacity: 0.6;
}

/*
 * Рамка — на ОБЁРТКЕ, а не на поле: ровно поэтому `Textarea` из кита сюда не подошёл (у него
 * `composes: field`, то есть рамка и фокус-кольцо на самом `<textarea>`). Фокус-кольцо здесь
 * совпадает с `field.module.css` дословно — но приезжает от `:focus-within` обёртки.
 */
.field {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 6px 6px 6px 13px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--bg);
}
.field:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

/*
 * Высоту ведёт JS (`useLayoutEffect` в MessageComposer): поле растёт под текст до 110px, дальше
 * прокручивается внутри себя. `max-height` из макета — свидетельство того, что поле именно растёт:
 * у `rows=1` без роста ограничивать было бы нечего.
 */
.input {
  flex: 1;
  min-width: 0;
  padding: 6px 0;
  border: 0;
  background: transparent;
  outline: none;
  resize: none;
  color: var(--ink);
  font: inherit;
  font-size: 13px;
  line-height: 1.4;
  max-height: 110px;
}

/*
 * Плейсхолдер — `--ink-3`, как у ВСЕХ полей проекта (`shared/ui/input`, `shared/ui/textarea`,
 * `features/global-search`). В макете он не покрашен вовсе, и без этой строки поле берёт
 * умолчание браузера — `rgb(117,117,117)`, ОДНО И ТО ЖЕ в обеих темах. Замерено по живым пикселям:
 * 4.28 в светлой и 3.99 в тёмной — AA (4.5) не берёт ни там, ни там, а плейсхолдер здесь виден
 * почти всегда: композер пуст, пока в него не пишут.
 *
 * С `--ink-3`: 5.16 и 5.46. Токен не выбран заново — он тот же, что у всех полей кита.
 */
.input::placeholder {
  color: var(--ink-3);
}

.sendButton {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 9px;
  background: var(--accent);
  color: var(--on-accent);
  cursor: pointer;
}
/* Hover — из копии композера на экране «Чаты» (prototype:1365). В копии карточки его просто не
   проставили: это единственная кнопка ленты, у которой две копии макета разошлись поведением. */
.sendButton:hover {
  filter: brightness(1.05);
}

/* Меню выбора канала — внутри Popover'а кита (он даёт фон/рамку/тень/паддинг панели). */
.menu {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 200px;
}

.menuTitle {
  margin: 0;
  padding: 4px 9px 6px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--ink-4);
}

.menuItem {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  height: 34px;
  padding: 0 9px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--ink);
  font: inherit;
  font-size: 12.5px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.menuItem:hover:not(:disabled) {
  background: var(--sunk);
}

.menuItem:disabled {
  color: var(--ink-4);
  cursor: default;
}

.menuDot {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--msg);
}

.menuItem:disabled .menuDot {
  opacity: 0.4;
}

.menuLabel {
  flex: 1;
  min-width: 0;
}

.menuUnavail {
  flex-shrink: 0;
  font-size: 10px;
  color: var(--ink-4);
}

.menuCheck {
  flex-shrink: 0;
  color: var(--accent);
}
